import { Col } from "antd"
import React from "react"
import { useQueryClient } from "react-query"
import { fetchEnrolment } from "../network/useEnrolment"
import { MyLearningCard } from "./cards/MyLearningCard"

export function CourseLearning({ courses }) {
  const queryClient = useQueryClient()

  if (!Array.isArray(courses) || !courses.length) return null

  return (
    <>
      {courses.map((course) => (
        <Col key={course.uid} xs={24} md={12}>
          <MyLearningCard
            enrolment={course}
            onMouseEnter={() =>
              queryClient.prefetchQuery([course.uid], () => fetchEnrolment(course.uid, queryClient), {
                staleTime: 1000 * 30,
              })
            }
          />
        </Col>
      ))}
    </>
  )
}
